<template>
  <div class="property_wraps">
    <div class="pro_top">轮播图设置</div>
    <div class="pro_con">
      <!-- <el-form ref="form" label-width="80px"> -->
	  <el-form ref="form">
        <!-- <el-form-item label="图片编辑:"> -->
		<el-form-item>
			<!-- :file-list="fileList" -->
			<div class="Box" v-for="(item,index) in property.pic" :key="index">
				<div class="imgBox">
					<img :src="item.response.path" alt="">
				</div>
				<div class="chooseBox">
					<div style="margin-left: 5px;">
						<span class="font17">跳转路径:</span>
						<el-select v-model="item.subtype" placeholder="请选择" @change="select(index,item)">
						    <el-option
						      v-for="item in options"
						      :key="item.subtype"
						      :label="item.content"
						      :value="item.subtype">
						    </el-option>
						</el-select>
					</div>
					<div v-if="item.subtype==2">
						<div class="chooseProducts font17" v-if="item.Name!=''">已选商品: <span>{{item.Name}}</span></div>
						<div style="margin-top: 40px;" v-if="item.Name==''">
							<el-popover
							  placement="right"
							  width="900"
								v-model="visible"
							  trigger="manual">
									<div class="Box2">
										<div class="BoxTop">
											<span>选择已上架商品</span>
											<i class="el-icon-close"></i>
										</div>
										<div class="BoxTop2">
											<div class="search_wrap">
											  <el-form :inline="true" :model="formdata" class="form-inline">
											    <el-form-item>
											      <el-cascader
											              placeholder="请选择分类"
											              :options="cateoptions"
											              expand-trigger="hover"
											              v-model="formdata.cat_id"
											              :props="defaultprops"
											              change-on-select
											              :show-all-levels="false"
											              size="small"
											      ></el-cascader>
											    </el-form-item>
											    <el-form-item>
											      <el-select clearable v-model="formdata.goods_type" placeholder="请选择商品类型" size="small">
											        <el-option
											                v-for="(item,index) in goodstype"
											                :value="item.value"
											                :label="item.label"
											                :key="index"
											        ></el-option>
											      </el-select>
											    </el-form-item>
											    <el-form-item>
											      <el-input v-model="formdata.name" placeholder="请输入商品名称" size="small">
											        <el-button slot="append" icon="el-icon-search" @click="init" size="small"></el-button>
											      </el-input>
											    </el-form-item>
											  </el-form>
											</div>
											<el-button class="Btn" :plain="true" @click="ensure(item,index)">确定选择</el-button>
										</div>
										<div class="tableBox" @scroll="handleScroll($event)">
											  <el-table :data="tableData" style="width: 100%" highlight-current-row @current-change="rowClick">
											    <el-table-column  width="55">
													<template slot-scope="scope">
													      <el-radio :label="scope.row.id" v-model="radioId">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio>
													    </template>
												</el-table-column>
											    <el-table-column label="商品图片" align="center">
											      <template slot-scope="scope">
											        <div class="td_img">
											          <img :src="scope.row.goods_thumb" alt/>
											        </div>
											      </template>
											    </el-table-column>
											    <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
											    <el-table-column prop="cat_id" label="所属分类" align="center">
											      <template slot-scope="scope">{{scope.row.cat_id[0]}}</template>
											    </el-table-column>
											    <el-table-column label="商品类别" align="center">
											      <template slot-scope="scope">{{gettypelabel(scope.row.type)}}</template>
											    </el-table-column>
											    <el-table-column prop="shop_price" width="120" label="商品单价" align="center"></el-table-column>
											    <el-table-column prop="goods_number" label="库存" align="center"></el-table-column>
											    <el-table-column prop="create_time" width="120" label="创建时间" align="center"></el-table-column>
											  </el-table>
											  <div class="pag_wrap">
											    <el-pagination
											            background
											            @current-change="pageIndexChange"
											            :page-size="page.pagesize"
											            :current-page="page.pageindex"
											            layout="total, prev, pager, next"
											            :total="page.total"
											    ></el-pagination>
											  </div>
										</div>
									</div>
							  <el-button slot="reference" class="Btn" @click="visible = !visible">选择商品</el-button>
							</el-popover>
							<!-- <button class="Btn" @click="choice">选择商品</button> -->
						</div>
						<div style="margin-top: 20px;" v-if="item.Name!=''">
							<el-popover
							  placement="right"
							  width="900"
								v-model="visibles"
							  trigger="manual">
									<div class="Box2">
										<div class="BoxTop">
											<span>选择已上架商品</span>
											<i class="el-icon-close"></i>
										</div>
										<div class="BoxTop2">
											<div class="search_wrap">
											  <el-form :inline="true" :model="formdata" class="form-inline">
											    <el-form-item>
											      <el-cascader
											              placeholder="请选择分类"
											              :options="cateoptions"
											              expand-trigger="hover"
											              v-model="formdata.cat_id"
											              :props="defaultprops"
											              change-on-select
											              :show-all-levels="false"
											              size="small"
											      ></el-cascader>
											    </el-form-item>
											    <el-form-item>
											      <el-select clearable v-model="formdata.goods_type" placeholder="请选择商品类型" size="small">
											        <el-option
											                v-for="(item,index) in goodstype"
											                :value="item.value"
											                :label="item.label"
											                :key="index"
											        ></el-option>
											      </el-select>
											    </el-form-item>
											    <el-form-item>
											      <el-input v-model="formdata.name" placeholder="请输入商品名称" size="small">
											        <el-button slot="append" icon="el-icon-search" @click="init" size="small"></el-button>
											      </el-input>
											    </el-form-item>
											  </el-form>
											</div>
											<el-button class="Btn" :plain="true" @click="ensures(item,index)">确定选择</el-button>
										</div>
										<div class="tableBox" @scroll="handleScroll($event)">
											  <el-table :data="tableData" style="width: 100%" highlight-current-row @current-change="rowClick">
											    <el-table-column  width="55">
													<template slot-scope="scope">
													      <el-radio :label="scope.row.id" v-model="radioId">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio>
													    </template>
												</el-table-column>
											    <el-table-column label="商品图片" align="center">
											      <template slot-scope="scope">
											        <div class="td_img">
											          <img :src="scope.row.goods_thumb" alt/>
											        </div>
											      </template>
											    </el-table-column>
											    <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
											    <el-table-column prop="cat_id" label="所属分类" align="center">
											      <template slot-scope="scope">{{scope.row.cat_id[0]}}</template>
											    </el-table-column>
											    <el-table-column label="商品类别" align="center">
											      <template slot-scope="scope">{{gettypelabel(scope.row.type)}}</template>
											    </el-table-column>
											    <el-table-column prop="shop_price" width="120" label="商品单价" align="center"></el-table-column>
											    <el-table-column prop="goods_number" label="库存" align="center"></el-table-column>
											    <el-table-column prop="create_time" width="120" label="创建时间" align="center"></el-table-column>
											  </el-table>
											  <div class="pag_wrap">
											    <el-pagination
											            background
											            @current-change="pageIndexChange"
											            :page-size="page.pagesize"
											            :current-page="page.pageindex"
											            layout="total, prev, pager, next"
											            :total="page.total"
											    ></el-pagination>
											  </div>
										</div>
									</div>
							  <el-button slot="reference" class="Btn" @click="visibles = !visibles">重新选择</el-button>
							</el-popover>
							<!-- <button class="Btn" @click="reselection">重新选择</button> -->
						</div>
					</div>
				</div>
			</div>
			
          <el-upload
              :action="uploadImg"
              :data="data_"
              list-type="picture-card"
              :limit="9"
              :file-list="fileList"
              :on-success="handleSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :before-upload="beforeAvatarUpload">
			  <!-- <div slot="file" slot-scope="{file}">
				  <div class="Box" v-for="(item,index) in property.pic" :key="index">
				  	<div class="imgBox">
				  		<img :src="item.response.path" alt="">
						<span class="el-upload-list__item-actions">
							<span
							  class="el-upload-list__item-preview"
							  @click="handlePictureCardPreview(file)"
							>
							  <i class="el-icon-zoom-in"></i>
							</span>
							<span
							  v-if="!disabled"
							  class="el-upload-list__item-delete"
							  @click="handleRemove(file)"
							>
							  <i class="el-icon-delete"></i>
							</span>
						</span>
				  	</div>
				  	<div class="chooseBox">
				  		<div style="margin-left: 5px;">
				  			<span class="font17">跳转路径:</span>
				  			<el-select v-model="item.subtype" placeholder="请选择" @change="select(index,item)">
				  			    <el-option
				  			      v-for="item in options"
				  			      :key="item.subtype"
				  			      :label="item.content"
				  			      :value="item.subtype">
				  			    </el-option>
				  			</el-select>
				  		</div>
				  		<div v-if="item.subtype==2">
				  			<div class="chooseProducts font17" v-if="item.Name!=''">已选商品:{{item.Name}}</div>
				  			<div style="margin-top: 40px;" v-if="item.Name==''">
				  				<el-popover
				  				  placement="right"
				  				  width="900"
				  					v-model="visible"
				  				  trigger="manual">
				  						<div class="Box2">
				  							<div class="BoxTop">
				  								<span>选择已上架商品</span>
				  								<i class="el-icon-close"></i>
				  							</div>
				  							<div class="BoxTop2">
				  								<div class="search_wrap">
				  								  <el-form :inline="true" :model="formdata" class="form-inline">
				  								    <el-form-item>
				  								      <el-cascader
				  								              placeholder="请选择分类"
				  								              :options="cateoptions"
				  								              expand-trigger="hover"
				  								              v-model="formdata.cat_id"
				  								              :props="defaultprops"
				  								              change-on-select
				  								              :show-all-levels="false"
				  								              size="small"
				  								      ></el-cascader>
				  								    </el-form-item>
				  								    <el-form-item>
				  								      <el-select clearable v-model="formdata.goods_type" placeholder="请选择商品类型" size="small">
				  								        <el-option
				  								                v-for="(item,index) in goodstype"
				  								                :value="item.value"
				  								                :label="item.label"
				  								                :key="index"
				  								        ></el-option>
				  								      </el-select>
				  								    </el-form-item>
				  								    <el-form-item>
				  								      <el-input v-model="formdata.name" placeholder="请输入商品名称" size="small">
				  								        <el-button slot="append" icon="el-icon-search" @click="init" size="small"></el-button>
				  								      </el-input>
				  								    </el-form-item>
				  								  </el-form>
				  								</div>
				  								<el-button class="Btn" :plain="true" @click="ensure(item,index)">确定选择</el-button>
				  							</div>
				  							<div class="tableBox" @scroll="handleScroll($event)">
				  								  <el-table :data="tableData" style="width: 100%" highlight-current-row @current-change="rowClick">
				  								    <el-table-column  width="55">
				  										<template slot-scope="scope">
				  										      <el-radio :label="scope.row.id" v-model="radioId">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio>
				  										    </template>
				  									</el-table-column>
				  								    <el-table-column label="商品图片" align="center">
				  								      <template slot-scope="scope">
				  								        <div class="td_img">
				  								          <img :src="scope.row.goods_thumb" alt/>
				  								        </div>
				  								      </template>
				  								    </el-table-column>
				  								    <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
				  								    <el-table-column prop="cat_id" label="所属分类" align="center">
				  								      <template slot-scope="scope">{{scope.row.cat_id[0]}}</template>
				  								    </el-table-column>
				  								    <el-table-column label="商品类别" align="center">
				  								      <template slot-scope="scope">{{gettypelabel(scope.row.type)}}</template>
				  								    </el-table-column>
				  								    <el-table-column prop="shop_price" width="120" label="商品单价" align="center"></el-table-column>
				  								    <el-table-column prop="goods_number" label="库存" align="center"></el-table-column>
				  								    <el-table-column prop="create_time" width="120" label="创建时间" align="center"></el-table-column>
				  								  </el-table>
				  								  <div class="pag_wrap">
				  								    <el-pagination
				  								            background
				  								            @current-change="pageIndexChange"
				  								            :page-size="page.pagesize"
				  								            :current-page="page.pageindex"
				  								            layout="total, prev, pager, next"
				  								            :total="page.total"
				  								    ></el-pagination>
				  								  </div>
				  							</div>
				  						</div>
				  				  <el-button slot="reference" class="Btn" @click="visible = !visible">选择商品</el-button>
				  				</el-popover>
				  			</div>
				  			<div style="margin-top: 20px;" v-if="item.Name!=''">
				  				<el-popover
				  				  placement="right"
				  				  width="900"
				  					v-model="visibles"
				  				  trigger="manual">
				  						<div class="Box2">
				  							<div class="BoxTop">
				  								<span>选择已上架商品</span>
				  								<i class="el-icon-close"></i>
				  							</div>
				  							<div class="BoxTop2">
				  								<div class="search_wrap">
				  								  <el-form :inline="true" :model="formdata" class="form-inline">
				  								    <el-form-item>
				  								      <el-cascader
				  								              placeholder="请选择分类"
				  								              :options="cateoptions"
				  								              expand-trigger="hover"
				  								              v-model="formdata.cat_id"
				  								              :props="defaultprops"
				  								              change-on-select
				  								              :show-all-levels="false"
				  								              size="small"
				  								      ></el-cascader>
				  								    </el-form-item>
				  								    <el-form-item>
				  								      <el-select clearable v-model="formdata.goods_type" placeholder="请选择商品类型" size="small">
				  								        <el-option
				  								                v-for="(item,index) in goodstype"
				  								                :value="item.value"
				  								                :label="item.label"
				  								                :key="index"
				  								        ></el-option>
				  								      </el-select>
				  								    </el-form-item>
				  								    <el-form-item>
				  								      <el-input v-model="formdata.name" placeholder="请输入商品名称" size="small">
				  								        <el-button slot="append" icon="el-icon-search" @click="init" size="small"></el-button>
				  								      </el-input>
				  								    </el-form-item>
				  								  </el-form>
				  								</div>
				  								<el-button class="Btn" :plain="true" @click="ensures(item,index)">确定选择</el-button>
				  							</div>
				  							<div class="tableBox" @scroll="handleScroll($event)">
				  								  <el-table :data="tableData" style="width: 100%" highlight-current-row @current-change="rowClick">
				  								    <el-table-column  width="55">
				  										<template slot-scope="scope">
				  										      <el-radio :label="scope.row.id" v-model="radioId">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio>
				  										    </template>
				  									</el-table-column>
				  								    <el-table-column label="商品图片" align="center">
				  								      <template slot-scope="scope">
				  								        <div class="td_img">
				  								          <img :src="scope.row.goods_thumb" alt/>
				  								        </div>
				  								      </template>
				  								    </el-table-column>
				  								    <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
				  								    <el-table-column prop="cat_id" label="所属分类" align="center">
				  								      <template slot-scope="scope">{{scope.row.cat_id[0]}}</template>
				  								    </el-table-column>
				  								    <el-table-column label="商品类别" align="center">
				  								      <template slot-scope="scope">{{gettypelabel(scope.row.type)}}</template>
				  								    </el-table-column>
				  								    <el-table-column prop="shop_price" width="120" label="商品单价" align="center"></el-table-column>
				  								    <el-table-column prop="goods_number" label="库存" align="center"></el-table-column>
				  								    <el-table-column prop="create_time" width="120" label="创建时间" align="center"></el-table-column>
				  								  </el-table>
				  								  <div class="pag_wrap">
				  								    <el-pagination
				  								            background
				  								            @current-change="pageIndexChange"
				  								            :page-size="page.pagesize"
				  								            :current-page="page.pageindex"
				  								            layout="total, prev, pager, next"
				  								            :total="page.total"
				  								    ></el-pagination>
				  								  </div>
				  							</div>
				  						</div>
				  				  <el-button slot="reference" class="Btn" @click="visibles = !visibles">重新选择</el-button>
				  				</el-popover>
				  			</div>
				  		</div>
				  		
				  	</div>
				  </div>
			  </div> -->
            <!-- <i class="el-icon-plus"></i> -->
			<button class="btn">
				<i class="el-icon-plus"></i>
				添加图片
			</button>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          <p class="infodescribe">图片大小不超过1M,支持jpg、png格式，最多可上传9张</p>
          <p class="infodescribe">建议所有轮播图比例一致，轮播效果更佳</p>
		  
		  
		  <!-- <input 
		      type="file" 
		      name="avatar" 
		      accept="image/gif,image/jpeg,image/jpg,image/png" 
		      style="display:none" 
		      @change="changeImage($event)" 
		      ref="avatarInput" /> -->
			  <!-- <div>
			      <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png" @change="inputFileChange"> 
			      <button type="primary" size="mini" @click="clicks">上传<button>
			    </div> -->
          <!--<div style="display: none">-->
            <!--<uploadImg :picimg="form.pic" @getChildValue="getChildValue" imgNumber="10"></uploadImg>-->
          <!--</div>-->
          <!--<div>-->
            <!--<draggable v-model="form.pic" :options="{draggable:'.draggableItem',animation: 150}" :move="getdata"-->
                       <!--@update="datadragEnd" class="draggable-body-list">-->
              <!--<transition-group class="draggable-body">-->
                <!--<div v-for="(item,index) in form.pic" :key="item" class="draggableItem" :draggable="draggable"-->
                     <!--:style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"-->
                     <!--:class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">-->
                  <!--<i class="el-icon-circle-close" @click="detelFn(index)"></i>-->
                <!--</div>-->
              <!--</transition-group>-->
            <!--</draggable>-->
          <!--</div>-->
          <!--<div class="pro_con">-->
            <!--<div class="img_body" @click="showCropper">-->
              <!--<p class="img_up_text">点击上传</p>-->
            <!--</div>-->
            <!--<p class="prompInfo">第一张默认为封面,可以拖拽图片调整顺序，最多上传9张，尺寸750*1048比例，大小在2M以内</p>-->
            <!--&lt;!&ndash;end&ndash;&gt;-->
          <!--</div>-->
        </el-form-item>
      </el-form>
    </div>
    <!--<corpper :visible.sync="corppervisible" v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>-->
  </div>
</template>
<script>
	import {
	  // pagination,
	  checktype,
	  getlabelbykey,
	  goodtype,
	  goodstype
	} from "@/util/util.js";
  import corpper from "@/components/dialog/corpper.vue";
  import draggable from 'vuedraggable';
  import api from "@/api.js"
  import uploadImg from "@/components/dialog/uploadImg.vue";
  export default {
    props: ["property"],
    components: {
      corpper,
      draggable,
      uploadImg
    },
    data() {
      return {
        // corpper
		options: [],
		 // options: [{
		 //          value: '1',
		 //          label: '无'
		 //        }, {
		 //          value: '2',
		 //          label: '商品'
		 //        }, {
		 //          value: '3',
		 //          label: '名片首页'
		 //        }, {
		 //          value: '4',
		 //          label: '动态'
		 //        }, {
		 //          value: '5',
		 //          label: '官网'
		 //        }, {
		 //          value: '6',
		 //          label: '个人中心'
		 //        }],
		//         value: '',
		name: '',
		visible: false,
		visibles: false,
		disabled: false,
		radioId: '',
				defaultprops: {
				  value: "id",
				  label: "name",
				  children: "child"
				},
				formdata: {
				  check_type: 1,//筛选类型(0全部、1已上架、2已售罄、3未上架)
				  goods_type: 0,//商品类型(0全部、1实体商品-仅线上展示、2实体商品-支持线上支付、3虚拟商品)
				  name: "",
				  cat_id: [],
				},
				tableData: [],
				page: {
				  // pageindex: pagination.pageIndex,//当前页码
				  // pagesize: pagination.pageSize,//每页显示条数
				  // total: pagination.total
				  pageindex: 1,//当前页码
				  pagesize: 10,//每页显示条数
				  total: 0
				},
				checktype: checktype,
				goodstype: goodstype,
				multipleSelection: [],
				// options: [],
				cateoptions: [],
				type: "",
				// currentPage:1,//当前页码
				// pageSize: 10,//每页显示条数
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        imgSize: 2,
        corppervisible: false,
        currentindex:0,
        // end
        dialogImageUrl: '',
        dialogVisible: false,
        fileList:[],
        form: {
          pic: []
        }
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          let fileList = []
          for(let i in val.pic){
            let fileList_line = {};
            fileList_line.name = i;
            fileList_line.url = val.pic[i];
            fileList.push(fileList_line)
          }
          this.fileList = fileList
          this.form = val
        }
      }
    },
    created(){
		this.querycatelist()
		this.init()
		this.InitFn()
		console.log(this.property,"this.property361===---====-----*****")
      if(this.property.pic.length!==0){
        let fileList = []
        for(let i in this.property.pic){
          let fileList_line = {};
          fileList_line.name = i;
          fileList_line.url = this.property.pic[i].response.path;
		  // if(this.property.pic[i].id)
          fileList.push(fileList_line)
        }
        this.fileList = fileList
      }
	  
	  // this.select()
	  this.fileList = this.fileList;
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
		inputFileChange(e){
			console.log(e,"e398==**==**==---")
		// this.files = e.target.files[0] //当input中选择文件时触发一个事件并让data当中的files拿到所选择的文件
		},
		select(e,item,index){
			console.log(e,item,index,this.fileList,"fileList176")
			this.fileList = this.fileList;
		},
      handleRemove(file, fileList) {
		  // console.log(fileList,"fileList125==========")
        let pic = [];
        for (let i in  fileList) {
          if(fileList[i].response){
            pic.push(fileList[i].response.path)
          }else{
            pic.push(fileList[i].url);
          };
        };
        this.form.pic = pic;
		this.fileList = fileList
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleSuccess(response, file, fileList) {
		  console.log(response,file,fileList,"file148=======")
		  // console.log(fileList,"fileList141==========")
        if (response.code === 0) {
          let pic = [];
          for (let i in fileList) {
			  // fileList[i].value = "1"
			  
            if(fileList[i].response){
              pic.push(fileList[i].response.path)
            }else{
              pic.push(fileList[i].url);
            };
			// pic.push(fileList[i])
          };
		  
          this.form.pic=fileList;
          this.fileList = fileList;
		  for (let i in this.fileList){
			  
			  if(this.fileList[i].Name){
			  		this.fileList[i].Name=fileList[i].Name
			  }else{
			  		this.fileList[i].Name = ""
			  }
		  }
		  console.log(this.fileList,this.form.pic,"this.fileList207")
        } else {
          this.$message.error(res.msg);
        }
        this.loadingStatus.close();
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;

        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 1MB!');
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        return isLt2M;
      },
	  // 底部导航查询
	  InitFn() {
		  this.options = [{subtype: '0',content: '无'},]
	    this.axios
	        .post(api.bottom_navigation_index, {})
	        .then(response => {
				// console.log(response,"response703==**==**==**==")
	          if (response.data.code == 0) { 
	            // this.company_id = response.data.company_id 
	            // this.iconBottonNav = response.data.info.bottom_navigation       
	            for(let i = 0; i < response.data.info.bottom_navigation.length; i++){
	              if (response.data.info.bottom_navigation[i].on_off == 1) {
	                this.options.push(response.data.info.bottom_navigation[i]);
	              }
	            }
				// console.log(this.options,"this.options725========")
	          } 
	        })
	        .catch(response => {
	        });
	  },
	  // 查询分类
	  querycatelist() {
	    let params = {};
	    this.axios
	        .post(api.goods_goods_cate_list, params)
	        .then(response => {
	          if (response.data.code == 0) {
	            this.cateoptions = this.translatecate(response.data.list || []);
	          } else {
	          }
	        })
	        .catch(response => {
	        });
	  },
	  // 转换分类数据
	  translatecate(data) {
	    if (data && data.length) {
	      data.forEach(item => {
	        if (item.child && item.child.length) {
	          item.child = this.translatecate(item.child);
	        } else {
	          item.child = null;
	        }
	      });
	    }
	    return data;
	  },
	  //初始化请求
	  init() {
	    this.page.pageindex = 1;
	    this.AccessToGoods();
	  },
	  //查询商品列表
	  AccessToGoods(){
		  let params = {
		    page: this.page.pageindex,
		    check_type: this.formdata.check_type,
		    goods_type: this.formdata.goods_type,
		    name: this.formdata.name,
		    cat_id: this.formdata.cat_id[this.formdata.cat_id.length - 1],
			size: this.page.pagesize
		  };
		  this.axios
		      .post(api.goods_index, params)
		      .then(response => {
				  // console.log(response,"response452====*********")
		        if (response.data.code == 0) {
		          this.tableData = response.data.list;
		          this.page.total = response.data.all_page;
		        } else {
		          this.page.total = 0;
		        }
				// console.log(this.tableData,"this.tableData756======****=====")
				if(this.property.pic.length!==0){
				  let fileList = []
				  for(let i in this.property.pic){
				    let fileList_line = {};
				    fileList_line.name = i;
				    fileList_line.url = this.property.pic[i].response.path;
					for(let j in this.tableData){
						if(this.property.pic[i].id == this.tableData[j].id){
							console.log(121513213)
							let Name = this.tableData[i].goods_name
							console.log(Name,"Name")
							this.property.pic[i].Name = Name
						}
					}
						  // if(this.property.pic[i].id)
				    fileList.push(fileList_line)
				  }
				  this.fileList = fileList
				}
		      })
		      .catch(response => {
		      });
	  },
	  // 分页
	  pageIndexChange(pageindex) {
	    this.page.pageindex = pageindex;
	    this.AccessToGoods();
	  },
	  gettypelabel(type) {
	    return getlabelbykey(goodtype, type);
	  },
	  // 切换状态
	  changetype() {
	    this.page.pageindex = 1;
	    this.AccessToGoods();
	  },
	  // 选择表格行
	  handleSelectionChange(val) {
	    this.multipleSelection = val;
	  },
	  /** 单选 */
	  rowClick(row) {
	    console.log(row.id, "row.id")
	    if (row) {
	      this.radioId = row.id;
	    }
	  },
	  // 确定选择
	  ensure(e,item,index){
		  console.log(e,item,index,"e464****===***")
		  if(this.radioId){
			  this.visible = !this.visible
			  for(let i in this.tableData){
				  if(this.radioId == this.tableData[i].id){
					  // console.log(this.tableData[i].id,"this.tableData[i].id470****=====***===")
					  e.Name = this.tableData[i].goods_name
					  e.id = this.radioId
					  this.fileList[item] = e
					  // this.form.pic = this.fileList;
				  }
			  }
		  }else{
			  this.$message.error('请选择需要跳转的商品');
		  }
	  },
	  ensures(e,item){
	  		  console.log(e,item,"e464****===***")
	  		  if(this.radioId){
	  			  this.visibles = !this.visibles
	  			  for(let i in this.tableData){
	  				  if(this.radioId == this.tableData[i].id){
	  					  // console.log(this.tableData[i].id,"this.tableData[i].id470****=====***===")
	  					  e.Name = this.tableData[i].goods_name
						  this.fileList[item] = e
						  // this.form.pic = this.fileList;
	  				  }
	  			  }
	  		  }else{
	  			  this.$message.error('请选择需要跳转的商品');
	  		  }
	  },
	  // 重选
	  reselection(){
		  // console.log(111111)
		  // console.log(this.visible,"this.visible484==**==***")
		  this.visible = true
	  },
	  // 滚动条
	  handleScroll (e) {
	          let el = e.target
	          //判断是否到达div容器底部
	         if(el.scrollTop+el.clientHeight>=el.scrollHeight){
	         	//控制页数
	            this.pagesize=this.pagesize+1
	            //调用后台接口
	            // this.getAuditRecipeList()
	          }
	        },
	  
	  // 商品选择
	  // CommodityRadio(e){
		 //  console.log(e,"e393=====*****************")
	  // },
	  // handleCurrentChange(val) {
		 //  console.log(val,"val407")
	  //             this.currentPage = val;
	  //         },
	  // CommodityRadio(selection, row) {
		 //  console.log(selection, row,"selection, row393=============******")
	  //     // 清除 所有勾选项
	  //     this.$refs.multipleTable.clearSelection()
	  //     // 当表格数据都没有被勾选的时候 就返回
	  //     // 主要用于将当前勾选的表格状态清除
	  //     if(selection.length == 0) return
	  //     this.$refs.multipleTable.toggleRowSelection(row, true);
	  // },
	  // // 表格的选中 可以获得当前选中的数据
	  // selectionChange(val) {
	  //     // 将选中的数据存储起来
	  //     this.selectData = val
	  // },
	  // // 表格某一行的单击事件
	  // rowClick(row, column) {
	  //     const selectData = this.selectData
	  //     this.$refs.multipleTable.clearSelection()
	  //     if( selectData.length == 1 ) {
	  //         selectData.forEach(item => {
	  //             // 判断 如果当前的一行被勾选, 再次点击的时候就会取消选中
	  //             if (item == row) {
	  //                 this.$refs.multipleTable.toggleRowSelection(row, false);
	  //             }
	  //             // 不然就让当前的一行勾选
	  //             else {
	  //                 this.$refs.multipleTable.toggleRowSelection(row, true);
	  //             }
	  //         })
	  //     } 
	  //     else {
	  //         this.$refs.multipleTable.toggleRowSelection(row, true);
	  //     }
	  // },
      // 裁切
      // detelFn(index){
      //   this.form.pic.splice(index, 1)
      // },
      // indexLine(index) {
      //   this.currentindex = index
      // },
      // datadragEnd(evt) {
      //   this.currentindex = evt.newIndex
      // },
      // getdata(data) {
      // },
      // imgAddBack(option) {
      //   if(this.form.pic.length<9){
      //     this.form.pic.push(option)
      //   }else{
      //     this.$message({
      //       message: '组件最多9张图',
      //       type: 'warning'
      //     });
      //   }
      // },
      // showCropper() {
      //   this.corppervisible = true
      // },
      // uploadalbum(val) {
      //   this.form.pic = val;
      // },
      // getChildValue(option){
      //   this.form.pic = option
      // }
    }
  };
</script>

<style>
	.property_wraps{min-width: 420px;height: 100%;overflow: hidden auto;border: 1px solid rgb(226, 226, 226);background: #fff;}
	.Box{width: 100%;height: 130px;display: flex;border: 1px solid black;margin-bottom: 10px;background-color: whitesmoke;}
	.imgBox{width: 30%;height: 90%;margin-top: 1%;margin-left: 5px;}
	.imgBox >img{width: 100%;height: 100%;}
	.chooseBox{width: 65%;height: 100%;}
	.font17{font-size: 17px;}
	.chooseProducts{height: 20px;line-height: 20px;margin-left: 5px;}
	.chooseProducts >span{font-size: 15px;}
	.Btn{width: 110px;border-radius: 5px;height: 30px;margin-left: 5px;background-color: #0eb83a;color: white;font-size: 15px;line-height: 5px;}
	.Box2{width: 875px;height: auto;border: 1px solid gainsboro;}
	.BoxTop{width: 100%;height: 30px;line-height: 30px;display: flex;justify-content: space-between;border-bottom: 1px solid gainsboro;}
	.BoxTop >span{margin-left: 20px;}
	.BoxTop >i{line-height: 30px;margin-right: 10px;}
	.BoxTop2{width: 100%;display: flex;justify-content: space-between;height: 50px;line-height: 55px;}
	.BoxTop2 >button{margin-top: 13px;width: 80px;border-radius: 5px;background-color: #0eb83a;margin-right: 10px;}
	.el-input {width: 90%;margin-left: 15px;}
	.tableBox{width: 100%;height: 500px;overflow-y: auto;}
	.el-select{width: 155px;}
	.el-upload-list--picture-card .el-upload-list__item-actions{width: 32%;}
	.el-upload--picture-card{
		width: 100%;
		border: 0px;
		background-color: gainsboro;
	}
	.btn{
		width: 100px;
		height: 30px;
		background-color: dodgerblue;
		color: white;
		border-radius: 5px;
	}
	.el-upload--picture-card i{
		font-size: 15px;
		color: white;
	}
	.el-upload-list--picture-card .el-upload-list__item{
		width: 100%;
		display: flex;
	}
	/* .el-upload-list--picture-card .el-upload-list__item-thumbnail{
		width: 30%;
	} */
	.el-upload-list--picture-card .el-upload-list__item-status-label{
		    width: 0px;height: 0px;
	}
	.el-input--suffix .el-input__inner {
	    padding-right: 30px;
	    border-radius: 5px;
	}
	.el-checkbox__inner{border-radius: 10px;}
	/* .el-pagination{text-align: end;} */
	.search_wrap{padding-top: 10px;}
	.el-form-item__content .el-input-group {
	    vertical-align: initial;
	}
	.el-input-group__append{background-color: dodgerblue;color: aliceblue;}
</style>